import { OndigoNS } from '../modules/main.js';

(function () {
    'use strict';

    OndigoNS.Usercentrics = function () {

        var youtubeShowOverlay = function(elem, e) {
                if(!youtubeAllowed(e)) {
                    elem[0].getElementsByClassName('activate-usercentrics-youtube')[0].style.display = 'block';
                }
            },
            youtubeRemoveOverlay = function(elem, e) {
                if(youtubeAllowed(e)) {
                    elem[0].getElementsByClassName('activate-usercentrics-youtube')[0].style.display = 'none';
                }
            },
            youtubeAllowed = function (e) {
                window.yt_allowed = false;

                if(e.detail && e.detail.event === 'consent_status') {
                    window.yt_allowed = e.detail['YouTube Video'];
                    return e.detail['YouTube Video'];
                }
            },
            googlemapsShowOverlay = function(elem, e) {
                if(!googlemapsAllowed(e)) {
                    elem[0].getElementsByClassName('activate-usercentrics-googlemaps')[0].style.display = 'block';
                }
            },
            googlemapsRemoveOverlay = function(elem, e) {
                if(googlemapsAllowed(e)) {
                    elem[0].getElementsByClassName('activate-usercentrics-googlemaps')[0].style.display = 'none';
                }
            },
            googlemapsAllowed = function (e) {
                if(e.detail && e.detail.event === 'consent_status') {
                    return e.detail['Google Maps'];
                }
            },
            myonofficeShowOverlay = function(elem, e) {
                if(!myonofficeAllowed(e) && elem[0].getElementsByClassName('activate-usercentrics-myonoffice').length) {
                    elem[0].getElementsByClassName('activate-usercentrics-myonoffice')[0].style.display = 'block';
                }
            },
            myonofficeRemoveOverlay = function(elem, e) {
                if(myonofficeAllowed(e) && elem[0].getElementsByClassName('activate-usercentrics-myonoffice').length) {
                    elem[0].getElementsByClassName('activate-usercentrics-myonoffice')[0].style.display = 'none';
                }
            },
            myonofficeAllowed = function (e) {
                if(e.detail && e.detail.event === 'consent_status') {
                    return e.detail.onOffice;
                }
            },
            oguloShowOverlay = function(elem, e) {
                if(!oguloAllowed(e) && elem[0].getElementsByClassName('activate-usercentrics-ogulo').length) {
                    elem[0].getElementsByClassName('activate-usercentrics-ogulo')[0].style.display = 'block';
                }
            },
            oguloRemoveOverlay = function(elem, e) {
                if(oguloAllowed(e) && elem[0].getElementsByClassName('activate-usercentrics-ogulo').length) {
                    elem[0].getElementsByClassName('activate-usercentrics-ogulo')[0].style.display = 'none';
                }
            },
            oguloAllowed = function (e) {
                if(e.detail && e.detail.event === 'consent_status') {
                    return e.detail.Ogulo;
                }
            },
            provenExpertShowOverlay = function(elem, e) {
                if(!provenExpertAllowed(e) && elem[0].getElementsByClassName('activate-usercentrics-provenexpert').length) {
                    elem[0].getElementsByClassName('activate-usercentrics-provenexpert')[0].style.display = 'block';
                }
            },
            provenExpertRemoveOverlay = function(elem, e) {
                if(provenExpertAllowed(e) && elem[0].getElementsByClassName('activate-usercentrics-provenexpert').length) {
                    elem[0].getElementsByClassName('activate-usercentrics-provenexpert')[0].style.display = 'none';
                }
            },
            provenExpertAllowed = function (e) {
                if(e.detail && e.detail.event === 'consent_status') {
                    return e.detail['Proven Expert'];
                }
            };

        // reveal the public API
        return {
            youtubeShowOverlay: youtubeShowOverlay,
            youtubeRemoveOverlay: youtubeRemoveOverlay,
            youtubeAllowed: youtubeAllowed,
            googlemapsShowOverlay: googlemapsShowOverlay,
            googlemapsRemoveOverlay: googlemapsRemoveOverlay,
            googlemapsAllowed: googlemapsAllowed,
            myonofficeShowOverlay: myonofficeShowOverlay,
            myonofficeRemoveOverlay: myonofficeRemoveOverlay,
            myonofficeAllowed: myonofficeAllowed,
            oguloAllowed: oguloAllowed,
            oguloShowOverlay: oguloShowOverlay,
            oguloRemoveOverlay: oguloRemoveOverlay,
            provenExpertAllowed: provenExpertAllowed,
            provenExpertRemoveOverlay: provenExpertRemoveOverlay,
            provenExpertShowOverlay: provenExpertShowOverlay
        };
    }();
}());